import PermissionRoute from '@Src/_basic/helpers/PermissionRoute';
import { RouteConfig } from '@Src/app/BasicRouter';
import React, { memo } from 'react';
import CreateLegalStandardScreen from './screens/CreateCustomStandardScreen';
import LegalStandardsScreen from './screens/CustomStandardsScreen';
import SelectTypeScreen from './screens/SelectTypeScreen';
import ViewLegalStandardScreen from './screens/ViewCustomStandardScreen';

const routesConfig: RouteConfig[] = [
  {
    path: '/type/*',
    element: <SelectTypeScreen />,
  },
  {
    path: '/list/*',
    element: <LegalStandardsScreen />,
  },
  {
    path: '/view/*',
    element: <ViewLegalStandardScreen />,
  },
  {
    path: '/create/*',
    element: <CreateLegalStandardScreen />,
  },
];

const CustomStandards = () => PermissionRoute(routesConfig);

export default memo(CustomStandards);
